/**
 * Implement updating pause buttons state for videos that do not loop.
 */
(() => {
    function videoEnded(e) {
        // console.log('Video ended');

        H_Tools.video.togglePauseState(e.target.closest('.js-video'));
    }

    document.querySelectorAll('.js-no-loop-video').forEach((el) => {
        el.addEventListener('ended', videoEnded);
    });
})();
